module.exports = __webpack_public_path__ + "img/UTSAND-1.333e4233.jpg";